import { FilterFormDataType } from '../components';

export type DataType = FilterFormDataType;

export type MessageTypesEnum = 'filter-copied';
export const MessageTypesEnum = {
  FilterCopied: 'filter-copied' as MessageTypesEnum,
};

export interface MessageType {
  type: MessageTypesEnum;
  data: DataType;
}
